import { axios } from "@/lib/axios";

export const logout = async (): Promise<void> => {
  return await axios.post("/authentication/logout", undefined, {
    withCredentials: true,
  });
};
